module.exports = __webpack_public_path__ + "media/public/img/google-review-icon-01-a916ceb3171c4e593de7efb07b9648f5.svg";